import { FormControl } from '@material-ui/core';
import styled from 'styled-components';

const FormControlStyled = styled(FormControl)({
  marginTop: '10px',
});

export default FormControlStyled;
